import axios from 'axios';
import {populateFormdataWithObject} from "@/helperFunctions";

class VorbasseShopWp {
	install (vue) {
		vue.prototype.$vorbasseShopWp = this;
		this.ajaxurl = process.env.VUE_APP_SHOP_AJAX_ENDPOINT;
	}
	get (gets) {
		return new Promise((resolve, reject) => {
			axios({method: 'GET', url: this.ajaxurl + gets, headers: {'Content-Type': 'application/json'}})
			.then(response => {
				if (typeof response.data !== 'undefined' && typeof response.status !== 'undefined' && response.status === 200) {
					resolve(response.data)
				} else {
					reject(new Error('An error occured, please try again'))
				}
			}).catch(error => {
				reject(error)
			})
		})
	}
	post (data) {
		return new Promise((resolve, reject) => {
			const bodyFormData = populateFormdataWithObject(new FormData(),data);
			axios({ method: 'POST', data: bodyFormData, url: this.ajaxurl, headers: {'Content-Type': 'multipart/form-data' } })
			.then(response => {
				if (typeof response.status !== 'undefined' && typeof response.data !== 'undefined') {
					resolve(response.data)
				} else {
					reject(new Error('An error occured, please try again'))
				}
			}).catch(error => {
				reject(new Error(error))
			})
		})
	}
}

const vorbasseShopWp = new VorbasseShopWp();
export default vorbasseShopWp;

